import Consumer from "./context/Consumer";
import Provider from "./context/Provider";

const LocaleContext = {
  Consumer: Consumer,
  Provider: Provider,
}
export default LocaleContext;